import React, { createContext, useContext, useState, useEffect } from 'react';

const SubjectContext = createContext();

export function SubjectProvider({ children }) {
  const [subject, setSubjectState] = useState(() => {
    // Read from localStorage on init, default to 'rw' as placeholder
    if (typeof window !== 'undefined' && window.localStorage) {
      const saved = localStorage.getItem('selectedSubject');
      if (saved === 'rw' || saved === 'bw') return saved;
    }
    return 'rw';
  });

  const setSubject = (newSubject) => {
    setSubjectState(newSubject);
    if (typeof window !== 'undefined' && window.localStorage) {
      localStorage.setItem('selectedSubject', newSubject);
    }
  };

  // Called once user data is available (e.g. from GlobalNav after getMe())
  // Validates that the current subject is allowed for this user.
  // If not, switches to the correct one and updates localStorage.
  const validateSubjectForUser = (user) => {
    if (!user) return;

    const hasRW = !!user.has_rechnungswesen;
    const hasBW = !!user.has_betriebswirtschaft;

    setSubjectState((current) => {
      // If current subject is valid for this user, keep it
      if (current === 'rw' && hasRW) return current;
      if (current === 'bw' && hasBW) return current;

      // Current subject not allowed – pick the correct one
      let corrected = 'rw';
      if (!hasRW && hasBW) corrected = 'bw';
      else if (hasRW) corrected = 'rw';

      // Persist the corrected value
      if (typeof window !== 'undefined' && window.localStorage) {
        localStorage.setItem('selectedSubject', corrected);
      }
      return corrected;
    });
  };

  return (
    <SubjectContext.Provider value={{ subject, setSubject, validateSubjectForUser }}>
      {children}
    </SubjectContext.Provider>
  );
}

export function useSubject() {
  const context = useContext(SubjectContext);
  if (!context) {
    throw new Error('useSubject must be used within SubjectProvider');
  }
  return context;
}
